import { render, staticRenderFns } from "./CatalogueContentField.vue?vue&type=template&id=372cb7f2"
import script from "./CatalogueContentField.vue?vue&type=script&lang=js"
export * from "./CatalogueContentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports